export enum MachineDetectionMode {
  CONNECT_FIRST = "CONNECT_FIRST",
  CONNECT_FIRST_WITH_DETECTION = "CONNECT_FIRST_WITH_DETECTION",
  DETECT_FIRST = "DETECT_FIRST",
}
